/* ============================================
   FlujosMarketing — BPMN-style horizontal flow diagrams
   Clean, structured documentation of all marketing funnels
   SVG icons · Aligned branch conditions
   ============================================ */

import { useState, useRef } from 'react'
import { PageHeader } from '@/components/ui'

// ═══════════════════════════════════════════════
// SVG ICON LIBRARY
// ═══════════════════════════════════════════════

const sz = 16
const I = {
  user:      <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>,
  target:    <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>,
  form:      <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>,
  save:      <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>,
  calendar:  <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  mail:      <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
  phone:     <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>,
  link:      <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>,
  chat:      <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
  bot:       <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="10" rx="2"/><circle cx="12" cy="5" r="2"/><path d="M12 7v4"/><line x1="8" y1="16" x2="8" y2="16"/><line x1="16" y1="16" x2="16" y2="16"/></svg>,
  clipboard: <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/></svg>,
  check:     <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>,
  clock:     <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
  timer:     <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2 2"/><path d="M5 3L2 6"/><path d="M22 6l-3-3"/><line x1="12" y1="1" x2="12" y2="3"/></svg>,
  x:         <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>,
  ban:       <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>,
  shuffle:   <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 3 21 3 21 8"/><line x1="4" y1="20" x2="21" y2="3"/><polyline points="21 16 21 21 16 21"/><line x1="15" y1="15" x2="21" y2="21"/><line x1="4" y1="4" x2="9" y2="9"/></svg>,
  wave:      <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M7 11v-1a5 5 0 0 1 10 0v4a2 2 0 0 1-2 2h-1"/><path d="M11 18l-1 2"/><path d="M17.5 7A4.5 4.5 0 0 0 13 3"/></svg>,
  globe:     <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>,
  snowflake: <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="2" x2="12" y2="22"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M20 16l-4-4 4-4"/><path d="M4 8l4 4-4 4"/><path d="M16 4l-4 4-4-4"/><path d="M8 20l4-4 4 4"/></svg>,
  file:      <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>,
  zap:       <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>,
  move:      <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="5 9 2 12 5 15"/><polyline points="9 5 12 2 15 5"/><polyline points="15 19 12 22 9 19"/><polyline points="19 9 22 12 19 15"/><line x1="2" y1="12" x2="22" y2="12"/><line x1="12" y1="2" x2="12" y2="22"/></svg>,
  gitBranch: <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="6" y1="3" x2="6" y2="15"/><circle cx="18" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><path d="M18 9a9 9 0 0 1-9 9"/></svg>,
} as const

type IconKey = keyof typeof I

// ─── Flow Data Types ───

interface FlowStep {
  id: string
  icon: IconKey
  label: string
  sublabel?: string
  color: string
  preview?: {
    type: 'email' | 'whatsapp' | 'action' | 'page' | 'info'
    title: string
    content: string
  }
  linkToFlow?: string
}

interface FlowBranch {
  condition: string
  yes: FlowStep[]
  no: FlowStep[]
}

type FlowItem = FlowStep | FlowBranch

interface FlowDefinition {
  id: string
  title: string
  description: string
  triggerIcon: IconKey
  triggerColor: string
  /** Landing pages this flow applies to */
  pages?: { label: string; url: string; hasForm?: boolean; hasBooking?: boolean }[]
  steps: FlowItem[]
}

function isBranch(item: FlowItem): item is FlowBranch {
  return 'condition' in item
}

// ═══════════════════════════════════════════════
// FLOW DEFINITIONS
// ═══════════════════════════════════════════════

const FLOWS: FlowDefinition[] = [
  {
    id: 'landing-booking',
    title: 'Landing → Agendamiento',
    description: 'Flujo principal para todas las landings con CTA + formulario + booking.',
    triggerIcon: 'globe',
    triggerColor: 'var(--info)',
    pages: [
      { label: 'Home', url: 'https://www.1conecta.com/', hasForm: true, hasBooking: true },
      { label: 'Desarrollo de Software', url: 'https://www.1conecta.com/servicios/desarrollo', hasForm: true, hasBooking: true },
      { label: 'Consultoría Tecnológica', url: 'https://www.1conecta.com/servicios/consultoria', hasForm: true, hasBooking: true },
      { label: 'Soporte & Mantenimiento', url: 'https://www.1conecta.com/servicios/soporte', hasForm: false, hasBooking: false },
      { label: 'Monday.com', url: 'https://www.1conecta.com/plataformas/monday', hasForm: true, hasBooking: true },
      { label: 'Contacto', url: 'https://www.1conecta.com/contacto', hasForm: true, hasBooking: true },
    ],
    steps: [
      {
        id: 'visit', icon: 'user', label: 'Visitante llega', sublabel: 'Orgánico / Ads / Referral', color: 'var(--text-muted)',
        preview: { type: 'info', title: 'Puntos de entrada', content: '• 1conecta.com (Home)\n• /servicios/desarrollo\n• /servicios/consultoria\n• /servicios/soporte\n• /plataformas/monday\n• Meta Ads → /servicios/desarrollo#aplicar' },
      },
      {
        id: 'hero-cta', icon: 'target', label: 'Hero CTA', sublabel: '"Aplica al diagnóstico gratuito"', color: 'var(--primary-light)',
        preview: { type: 'page', title: 'Sección Hero', content: 'Botón primario en el Hero de cada landing.\nScroll suave a #aplicar donde está el formulario.\nMeta Pixel: PageView al cargar.' },
      },
      {
        id: 'form', icon: 'form', label: 'Formulario diagnóstico', sublabel: 'Nombre, email, empresa, cargo, WA', color: 'var(--info)',
        preview: { type: 'page', title: 'DiagnosticoForm.tsx', content: 'Campos:\n• Nombre completo\n• Email corporativo\n• Empresa\n• Cargo\n• WhatsApp\n• ¿Qué necesitas?\n• Rango de empleados\n• Presupuesto estimado\n\nValidación en frontend.\nPaso 1 → Paso 2 (datos + necesidad).' },
      },
      {
        id: 'lead-create', icon: 'save', label: 'Crear Lead', sublabel: 'POST /api/leads/public', color: 'var(--success)',
        preview: { type: 'action', title: 'API: Crear Lead en Pipeline', content: '1. Busca contacto existente por email\n2. Si no existe → crea contacto\n3. Crea lead en Pipeline (etapa: "lead")\n4. Vincula contacto ↔ lead\n5. Guarda formulario_datos como JSONB\n6. Registra UTM (source, medium, campaign)\n\nMeta Pixel: fbq("track", "Lead")' },
      },
      {
        id: 'booking', icon: 'calendar', label: 'Agendamiento', sublabel: 'SchedulePicker → selecciona slot', color: 'var(--warning)',
        preview: { type: 'action', title: 'SchedulePicker + POST /api/booking/agendar', content: '1. Muestra calendario con slots disponibles\n2. Verifica FreeBusy en Google Calendar\n3. Crea evento en Google Calendar + Meet\n4. Crea agendamiento en DB\n5. Vincula a lead + contacto\n6. Busca/crea conversación WhatsApp\n\nMeta Pixel: fbq("track", "Schedule")' },
      },
      {
        id: 'confirm', icon: 'mail', label: 'Confirmación', sublabel: 'Email + WA automáticos', color: 'var(--info)',
        preview: { type: 'email', title: 'Email: Tu sesión está confirmada', content: 'Asunto: Tu Sesión de Diagnóstico Gratuita está Confirmada\n\nContenido:\n• Detalles de la reunión (fecha, hora, duración)\n• Botón "Unirse a Google Meet"\n• Qué esperar en la sesión\n• Tips de preparación\n\nVía: Resend API' },
      },
      {
        id: 'link-seguimiento', icon: 'link', label: 'Seguimiento', sublabel: '→ Flujo Pre-Reunión', color: 'var(--primary-light)', linkToFlow: 'pre-meeting',
      },
    ],
  },

  {
    id: 'chatbot-valentina',
    title: 'Chatbot Valentina → WhatsApp',
    description: 'Flujo del chatbot IA Valentina en el widget web → captura lead → ofrece agendamiento.',
    triggerIcon: 'bot',
    triggerColor: 'var(--success)',
    steps: [
      {
        id: 'widget', icon: 'chat', label: 'Widget Chat', sublabel: 'chatbot.js en todas las páginas', color: 'var(--text-muted)',
        preview: { type: 'info', title: 'Widget Chatbot', content: 'Inyectado en 1conecta.com via <script>\nBurbuja flotante esquina inferior derecha\nApertura automática tras 30s de inactividad\nAgente: Valentina (slug: valentina)' },
      },
      {
        id: 'valentina-ai', icon: 'bot', label: 'Valentina IA', sublabel: 'Multi-agente Marco + Gemini', color: 'var(--primary-light)',
        preview: { type: 'action', title: 'Sistema Multi-Agente', content: 'POST /api/widget/chatbot\n\nRouter (Marco) distribuye a workers:\n• Saludo: Bienvenida personalizada\n• Ventas: Califica necesidad, presupuesto\n• Soporte: Responde FAQs\n• Booking: Ofrece diagnóstico gratuito\n\nModelo: Gemini 2.0 Flash\nContexto: KB articles + memoria' },
      },
      {
        id: 'capture-lead', icon: 'clipboard', label: 'Captura Lead', sublabel: 'Nombre + WhatsApp', color: 'var(--success)',
        preview: { type: 'action', title: 'POST /api/widget/capture-lead', content: 'Cuando el visitante muestra interés:\n1. Valentina pide nombre + WhatsApp\n2. POST /api/widget/capture-lead\n3. Crea lead en Pipeline (origen: "chatbot")\n4. Crea contacto si no existe\n5. Vincula contacto ↔ lead' },
      },
      {
        condition: '¿Quiere agendar?',
        yes: [
          {
            id: 'booking-chatbot', icon: 'calendar', label: 'Agendamiento', sublabel: 'Booking inline en chat', color: 'var(--warning)',
            preview: { type: 'action', title: 'Booking desde Chatbot', content: 'Valentina ofrece "¿Te gustaría agendar una sesión?"\n→ Muestra slots disponibles en el chat\n→ POST /api/booking/agendar\n→ Vincula a lead existente\n→ Email + WA confirmación' },
          },
          { id: 'link-seg-2', icon: 'link', label: 'Seguimiento', sublabel: '→ Flujo Pre-Reunión', color: 'var(--primary-light)', linkToFlow: 'pre-meeting' },
        ],
        no: [
          {
            id: 'handoff', icon: 'shuffle', label: 'Derivación', sublabel: 'WhatsApp / Email', color: 'var(--warning)',
            preview: { type: 'action', title: 'POST /api/widget/handoff', content: 'Si no quiere agendar pero quiere contacto:\n→ Deriva a WhatsApp directo (+51986252983)\n→ O envía email de seguimiento\n→ Lead queda en Pipeline etapa "contactado"' },
          },
          { id: 'thanks', icon: 'wave', label: 'Agradecimiento', sublabel: 'Cierre de conversación', color: 'var(--text-muted)' },
        ],
      },
    ],
  },

  {
    id: 'pre-meeting',
    title: 'Seguimiento Pre-Reunión',
    description: 'Recordatorios automáticos antes de la reunión agendada (24h, 1h). Detecta no-shows.',
    triggerIcon: 'calendar',
    triggerColor: 'var(--warning)',
    steps: [
      { id: 'booking-created', icon: 'check', label: 'Reunión agendada', sublabel: 'Trigger automático', color: 'var(--success)' },
      {
        id: 'wa-24h', icon: 'phone', label: 'WA Recordatorio 24h', sublabel: 'mensajes_programados', color: 'var(--success)',
        preview: { type: 'whatsapp', title: 'Recordatorio 24h antes', content: 'Hola {{nombre}}, te recordamos que mañana tienes tu Sesión de Diagnóstico Gratuita.\n\n{{fecha}} a las {{hora}}\nDuración: 30 minutos\n\n¡Nos vemos mañana!' },
      },
      {
        id: 'wa-1h', icon: 'phone', label: 'WA Recordatorio 1h', sublabel: 'Con link Google Meet', color: 'var(--success)',
        preview: { type: 'whatsapp', title: 'Recordatorio 1h antes', content: 'Tu reunión inicia en 1 hora.\n\nUnirse: {{meet_url}}\n{{fecha}} a las {{hora}}\n\n¡Te esperamos!' },
      },
      { id: 'meeting-time', icon: 'clock', label: 'Hora de reunión', sublabel: 'Google Meet', color: 'var(--info)' },
      {
        condition: '¿Asistió?',
        yes: [
          { id: 'link-post', icon: 'link', label: 'Post-Reunión', sublabel: '→ Flujo Post-Reunión', color: 'var(--success)', linkToFlow: 'post-meeting' },
        ],
        no: [
          { id: 'link-noshow', icon: 'link', label: 'No-Show', sublabel: '→ Flujo No-Show', color: 'var(--danger)', linkToFlow: 'no-show' },
        ],
      },
    ],
  },

  {
    id: 'no-show',
    title: 'Recuperación No-Show',
    description: 'Secuencia de recuperación cuando el prospecto no asiste a la reunión agendada.',
    triggerIcon: 'x',
    triggerColor: 'var(--danger)',
    steps: [
      { id: 'noshow-detected', icon: 'x', label: 'No-show detectado', sublabel: 'Manual o automático', color: 'var(--danger)' },
      { id: 'wait-30m', icon: 'timer', label: 'Esperar 30 min', sublabel: 'Delay', color: 'var(--warning)' },
      {
        id: 'email-noshow', icon: 'mail', label: 'Email: No pudimos conectar', sublabel: 'Link de reagendamiento', color: 'var(--info)',
        preview: { type: 'email', title: 'Email: No pudimos conectar', content: 'Asunto: No pudimos conectar hoy — reagendemos\n\nHola {{nombre}},\n\nNotamos que no pudimos encontrarnos en la reunión de hoy. No te preocupes, estas cosas pasan.\n\n¿Te gustaría reagendar?\n\n[Reagendar mi sesión] → link booking\n\nSaludos,\nEquipo 1Conecta' },
      },
      { id: 'wait-2h', icon: 'timer', label: 'Esperar 2h', sublabel: 'Delay', color: 'var(--warning)' },
      {
        id: 'wa-reagendar', icon: 'phone', label: 'WA: ¿Reagendamos?', sublabel: 'Mensaje directo', color: 'var(--success)',
        preview: { type: 'whatsapp', title: 'WhatsApp: Reagendamiento', content: 'Hola {{nombre}}\n\nNo pudimos conectar en la reunión de hoy. ¿Te gustaría reagendar?\n\nPuedes elegir un nuevo horario aquí:\n{{booking_url}}\n\n¡Quedo atento!' },
      },
      { id: 'wait-48h', icon: 'timer', label: 'Esperar 48h', sublabel: 'Último intento', color: 'var(--warning)' },
      {
        condition: '¿Reagendó?',
        yes: [
          { id: 'reagendo-ok', icon: 'link', label: 'Reagendó', sublabel: '→ Flujo Pre-Reunión', color: 'var(--success)', linkToFlow: 'pre-meeting' },
        ],
        no: [
          {
            id: 'email-final', icon: 'mail', label: 'Email último intento', sublabel: 'Mantener puerta abierta', color: 'var(--info)',
            preview: { type: 'email', title: 'Email: Último intento', content: 'Asunto: ¿Sigues interesado en optimizar tu operación?\n\nHola {{nombre}},\n\nTe escribo por última vez sobre la sesión de diagnóstico gratuita.\n\nSi tu situación cambió, lo entiendo perfectamente. El link estará disponible cuando quieras:\n\n[Agendar cuando quiera] → link booking\n\nÉxitos,\nEquipo 1Conecta' },
          },
          { id: 'lead-frio', icon: 'snowflake', label: 'Lead frío', sublabel: 'Pipeline: archivado', color: 'var(--text-muted)' },
        ],
      },
    ],
  },

  {
    id: 'post-meeting',
    title: 'Post-Reunión Completada',
    description: 'Seguimiento después de una reunión exitosa: agradecimiento y próximos pasos.',
    triggerIcon: 'check',
    triggerColor: 'var(--success)',
    steps: [
      { id: 'meeting-done', icon: 'check', label: 'Reunión completada', sublabel: 'Estado: completado', color: 'var(--success)' },
      { id: 'wait-1h-post', icon: 'timer', label: 'Esperar 1h', sublabel: 'Delay', color: 'var(--warning)' },
      {
        id: 'email-thanks', icon: 'mail', label: 'Email: Gracias', sublabel: 'Próximos pasos + propuesta', color: 'var(--info)',
        preview: { type: 'email', title: 'Email: Gracias por tu tiempo', content: 'Asunto: Gracias por tu tiempo — Próximos pasos\n\nHola {{nombre}},\n\nFue un placer conocerte y entender los retos de {{empresa}}.\n\nComo conversamos, estos son los próximos pasos:\n\n1. Te enviaremos una propuesta personalizada en 48h\n2. Incluirá diagnóstico + recomendaciones\n3. Agendaremos una llamada de revisión\n\n¿Alguna duda? Responde este email.\n\nSaludos,\nEquipo 1Conecta' },
      },
      {
        id: 'move-stage', icon: 'move', label: 'Mover lead', sublabel: 'Pipeline: "diagnóstico"', color: 'var(--primary-light)',
        preview: { type: 'action', title: 'Acción: Mover etapa', content: 'Lead se mueve automáticamente:\n\n"lead" → "diagnóstico"\n\nVisualizado en el Pipeline del CRM.' },
      },
      { id: 'cotizacion', icon: 'file', label: 'Crear cotización', sublabel: 'Manual en CRM', color: 'var(--info)' },
    ],
  },

  {
    id: 'cancellation',
    title: 'Cancelación de Reunión',
    description: 'Secuencia cuando el prospecto cancela la reunión agendada.',
    triggerIcon: 'ban',
    triggerColor: 'var(--warning)',
    steps: [
      { id: 'cancelled', icon: 'ban', label: 'Reunión cancelada', sublabel: 'Google Calendar + DB', color: 'var(--warning)' },
      {
        id: 'email-cancel', icon: 'mail', label: 'Email: Confirmación', sublabel: 'Confirmamos cancelación', color: 'var(--info)',
        preview: { type: 'email', title: 'Email: Cancelación confirmada', content: 'Asunto: Tu sesión ha sido cancelada\n\nHola {{nombre}},\n\nConfirmamos la cancelación de tu Sesión de Diagnóstico.\n\nSi cambias de opinión, puedes reagendar cuando quieras:\n\n[Reagendar sesión] → link booking\n\nSaludos,\nEquipo 1Conecta' },
      },
      {
        id: 'wa-cancel', icon: 'phone', label: 'WA: Lamentamos', sublabel: 'Mensaje empático', color: 'var(--success)',
        preview: { type: 'whatsapp', title: 'WhatsApp: Cancelación', content: 'Hola {{nombre}}, lamentamos que hayas cancelado tu sesión.\n\nSi tu agenda cambió, siempre puedes reagendar:\n{{booking_url}}\n\n¡Éxitos!' },
      },
      { id: 'wait-7d', icon: 'timer', label: 'Esperar 7 días', sublabel: 'Delay', color: 'var(--warning)' },
      {
        id: 'email-reinterest', icon: 'mail', label: 'Email: ¿Sigues interesado?', sublabel: 'Follow-up final', color: 'var(--info)',
        preview: { type: 'email', title: 'Email: ¿Sigues interesado?', content: 'Asunto: ¿Aún buscas optimizar tu operación?\n\nHola {{nombre}},\n\nHace una semana cancelaste tu sesión de diagnóstico. Quería saber si tu situación cambió.\n\nEl diagnóstico es gratuito y sin compromiso (30 min).\n\n[Reagendar mi sesión] → link booking\n\nSaludos,\nEquipo 1Conecta' },
      },
    ],
  },
]

// ═══════════════════════════════════════════════
// STYLES
// ═══════════════════════════════════════════════

const S = {
  page: { padding: '32px 40px', minHeight: '100vh', maxWidth: 1400, margin: '0 auto' } as React.CSSProperties,
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32 } as React.CSSProperties,
  title: { fontSize: 26, fontWeight: 700, color: 'var(--text-primary)', margin: 0 } as React.CSSProperties,
  subtitle: { fontSize: 14, color: 'var(--text-muted)', marginTop: 4 } as React.CSSProperties,
  btnBack: { background: 'var(--veil-06)', color: 'var(--text-secondary)', padding: '10px 18px', borderRadius: 10, fontWeight: 600, fontSize: 14, border: '1px solid var(--border)', cursor: 'pointer', transition: 'all 0.2s' } as React.CSSProperties,
  flowSection: { marginBottom: 40 } as React.CSSProperties,
  flowCard: { background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 16, overflow: 'hidden', transition: 'all 0.5s ease' } as React.CSSProperties,
  flowHeader: (c: string): React.CSSProperties => ({ padding: '18px 24px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 14, background: `${c}08` }),
  flowTrigger: (c: string): React.CSSProperties => ({ width: 36, height: 36, borderRadius: 10, background: `${c}20`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: c, flexShrink: 0 }),
  flowTitle: { fontSize: 16, fontWeight: 700, color: 'var(--text-primary)', margin: 0 } as React.CSSProperties,
  flowDesc: { fontSize: 12, color: 'var(--text-muted)', marginTop: 2 } as React.CSSProperties,
  flowBody: { padding: '28px 24px', overflowX: 'auto' as const } as React.CSSProperties,

  // ─── Steps ───
  flowRow: { display: 'flex', alignItems: 'center', gap: 0, minWidth: 'max-content' } as React.CSSProperties,
  step: (c: string, isLink: boolean): React.CSSProperties => ({
    display: 'flex', flexDirection: 'column' as const, alignItems: 'center', gap: 6,
    padding: '12px 16px',
    background: isLink ? `${c}10` : 'var(--veil-03)',
    border: `1.5px ${isLink ? 'dashed' : 'solid'} ${isLink ? `${c}30` : 'var(--veil-08)'}`,
    borderRadius: 12, minWidth: 130, maxWidth: 160,
    cursor: 'pointer', transition: 'all 0.2s ease', position: 'relative' as const,
  }),
  stepIcon: (c: string): React.CSSProperties => ({
    width: 32, height: 32, borderRadius: 8, background: `${c}18`,
    display: 'flex', alignItems: 'center', justifyContent: 'center', color: c,
  }),
  stepLabel: { fontSize: 12, fontWeight: 700, color: 'var(--text-primary)', textAlign: 'center' as const, lineHeight: 1.3 } as React.CSSProperties,
  stepSub: { fontSize: 10, color: 'var(--text-muted)', textAlign: 'center' as const, lineHeight: 1.3 } as React.CSSProperties,
  arrow: { display: 'flex', alignItems: 'center', padding: '0 4px', flexShrink: 0, color: 'var(--veil-12)' } as React.CSSProperties,

  // ─── BRANCH — ALIGNED ───
  branchWrapper: {
    display: 'flex', alignItems: 'center', gap: 0,
  } as React.CSSProperties,
  branchDiamond: {
    display: 'flex', flexDirection: 'column' as const, alignItems: 'center', justifyContent: 'center', gap: 4,
    padding: '14px 18px',
    background: 'color-mix(in srgb, var(--warning) 6%, transparent)',
    border: '2px solid color-mix(in srgb, var(--warning) 30%, transparent)',
    borderRadius: 12,
    minWidth: 120,
    position: 'relative' as const,
  } as React.CSSProperties,
  branchIcon: {
    color: 'var(--warning)', display: 'flex', alignItems: 'center', justifyContent: 'center',
  } as React.CSSProperties,
  branchLabel: { fontSize: 11, fontWeight: 700, color: 'var(--warning)', textAlign: 'center' as const } as React.CSSProperties,
  branchPaths: {
    display: 'flex', flexDirection: 'column' as const, gap: 12,
  } as React.CSSProperties,
  branchPath: {
    display: 'flex', alignItems: 'center', gap: 0,
  } as React.CSSProperties,
  branchTag: (isYes: boolean): React.CSSProperties => ({
    fontSize: 10, fontWeight: 800, letterSpacing: '0.5px',
    color: isYes ? 'var(--success)' : 'var(--danger)',
    background: isYes ? 'color-mix(in srgb, var(--success) 12%, transparent)' : 'rgba(239,68,68,0.12)',
    border: `1px solid ${isYes ? 'color-mix(in srgb, var(--success) 25%, transparent)' : 'rgba(239,68,68,0.25)'}`,
    padding: '4px 12px', borderRadius: 4, marginRight: 6, flexShrink: 0,
    minWidth: 28, textAlign: 'center' as const,
  }),
  branchLine: (isYes: boolean): React.CSSProperties => ({
    width: 20, height: 2,
    background: isYes ? 'color-mix(in srgb, var(--success) 30%, transparent)' : 'rgba(239,68,68,0.3)',
    flexShrink: 0,
  }),

  // ─── Preview ───
  previewOverlay: { position: 'fixed' as const, top: 0, left: 0, right: 0, bottom: 0, zIndex: 9998, background: 'transparent' } as React.CSSProperties,
  previewTitle: { fontSize: 13, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 6 } as React.CSSProperties,
  previewContent: { fontSize: 12, color: 'var(--text-secondary)', lineHeight: 1.6, whiteSpace: 'pre-wrap' as const } as React.CSSProperties,
  previewBubble: { background: '#DCF8C6', borderRadius: '12px 12px 4px 12px', padding: '10px 14px', fontSize: 12, color: '#111', lineHeight: 1.5, whiteSpace: 'pre-wrap' as const } as React.CSSProperties,
  previewEmailSubject: { background: 'color-mix(in srgb, var(--info) 10%, transparent)', border: '1px solid color-mix(in srgb, var(--info) 20%, transparent)', borderRadius: 6, padding: '6px 10px', fontSize: 11, fontWeight: 600, color: 'var(--info)', marginBottom: 8 } as React.CSSProperties,
}

// ─── Arrow SVG connector ───
function Arrow() {
  return (
    <div style={S.arrow}>
      <svg width="24" height="12" viewBox="0 0 24 12">
        <line x1="0" y1="6" x2="18" y2="6" stroke="var(--veil-20)" strokeWidth="2" />
        <polygon points="17,2 23,6 17,10" fill="var(--veil-25)" />
      </svg>
    </div>
  )
}

// ═══════════════════════════════════════════════
// STEP NODE
// ═══════════════════════════════════════════════

function StepNode({ step, onScrollToFlow }: { step: FlowStep; onScrollToFlow: (id: string) => void }) {
  const [showPreview, setShowPreview] = useState(false)
  const nodeRef = useRef<HTMLDivElement>(null)
  const isLink = !!step.linkToFlow

  const handleClick = () => {
    if (step.linkToFlow) {
      onScrollToFlow(step.linkToFlow)
    } else if (step.preview) {
      setShowPreview(!showPreview)
    }
  }

  // Calculate fixed position for the preview popup
  const getPreviewStyle = (): React.CSSProperties => {
    if (!nodeRef.current) return { display: 'none' }
    const rect = nodeRef.current.getBoundingClientRect()
    const popupWidth = 340
    // Center popup below the node
    let left = rect.left + rect.width / 2 - popupWidth / 2
    // Clamp to viewport
    if (left < 12) left = 12
    if (left + popupWidth > window.innerWidth - 12) left = window.innerWidth - popupWidth - 12
    // Show above if no space below
    const spaceBelow = window.innerHeight - rect.bottom
    const showAbove = spaceBelow < 250
    return {
      position: 'fixed',
      top: showAbove ? undefined : rect.bottom + 8,
      bottom: showAbove ? window.innerHeight - rect.top + 8 : undefined,
      left,
      width: popupWidth,
      zIndex: 10000,
      background: 'var(--bg-modal)',
      border: '1px solid var(--border-light)',
      borderRadius: 12,
      padding: 16,
      boxShadow: 'var(--shadow-lg)',
      maxHeight: 350,
      overflowY: 'auto' as const,
    }
  }

  return (
    <div ref={nodeRef} style={{ position: 'relative' }}>
      <div
        style={S.step(step.color, isLink)}
        onClick={handleClick}
        onMouseEnter={(e) => {
          e.currentTarget.style.borderColor = step.color
          e.currentTarget.style.background = `${step.color}12`
          e.currentTarget.style.transform = 'translateY(-2px)'
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.borderColor = isLink ? `${step.color}30` : 'var(--veil-08)'
          e.currentTarget.style.background = isLink ? `${step.color}10` : 'var(--veil-03)'
          e.currentTarget.style.transform = 'translateY(0)'
        }}
      >
        <div style={S.stepIcon(step.color)}>
          {I[step.icon]}
        </div>
        <div style={S.stepLabel}>{step.label}</div>
        {step.sublabel && <div style={S.stepSub}>{step.sublabel}</div>}
        {step.preview && !isLink && (
          <div style={{ position: 'absolute', top: 6, right: 6, width: 6, height: 6, borderRadius: '50%', background: step.color, opacity: 0.5 }} />
        )}
      </div>

      {showPreview && step.preview && (
        <>
          <div style={S.previewOverlay} onClick={() => setShowPreview(false)} />
          <div style={getPreviewStyle()}>
            <div style={S.previewTitle}>{step.preview.title}</div>
            {step.preview.type === 'whatsapp' ? (
              <div style={S.previewBubble}>{step.preview.content}</div>
            ) : step.preview.type === 'email' ? (
              <div>
                {step.preview.content.split('\n')[0]?.startsWith('Asunto:') && (
                  <div style={S.previewEmailSubject}>{step.preview.content.split('\n')[0]}</div>
                )}
                <div style={S.previewContent}>{step.preview.content.split('\n').slice(1).join('\n').trim()}</div>
              </div>
            ) : (
              <div style={S.previewContent}>{step.preview.content}</div>
            )}
          </div>
        </>
      )}
    </div>
  )
}

// ═══════════════════════════════════════════════
// FLOW ROW — renders a linear sequence of steps
// ═══════════════════════════════════════════════

function FlowRow({ items, onScrollToFlow }: { items: FlowItem[]; onScrollToFlow: (id: string) => void }) {
  return (
    <div style={S.flowRow}>
      {items.map((item, idx) => {
        const showArrow = idx > 0

        if (isBranch(item)) {
          return (
            <div key={`branch-${idx}`} style={S.branchWrapper}>
              {showArrow && <Arrow />}

              {/* Diamond condition */}
              <div style={S.branchDiamond}>
                <div style={S.branchIcon}>{I.gitBranch}</div>
                <div style={S.branchLabel}>{item.condition}</div>
              </div>

              {/* Connecting line from diamond to paths */}
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 12 }}>
                {/* Yes branch */}
                <div style={S.branchPath}>
                  <div style={S.branchLine(true)} />
                  <span style={S.branchTag(true)}>SÍ</span>
                  <FlowRow items={item.yes} onScrollToFlow={onScrollToFlow} />
                </div>
                {/* No branch */}
                <div style={S.branchPath}>
                  <div style={S.branchLine(false)} />
                  <span style={S.branchTag(false)}>NO</span>
                  <FlowRow items={item.no} onScrollToFlow={onScrollToFlow} />
                </div>
              </div>
            </div>
          )
        }

        return (
          <div key={item.id} style={{ display: 'flex', alignItems: 'center' }}>
            {showArrow && <Arrow />}
            <StepNode step={item} onScrollToFlow={onScrollToFlow} />
          </div>
        )
      })}
    </div>
  )
}

// ═══════════════════════════════════════════════
// MAIN PAGE
// ═══════════════════════════════════════════════

export default function FlujosMarketing() {

  const scrollToFlow = (flowId: string) => {
    const el = document.getElementById(`flow-${flowId}`)
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      el.style.borderColor = 'rgba(139,92,246,0.5)'
      el.style.boxShadow = '0 0 20px rgba(139,92,246,0.15)'
      setTimeout(() => {
        el.style.borderColor = 'var(--veil-06)'
        el.style.boxShadow = 'none'
      }, 2000)
    }
  }

  return (
    <div style={S.page}>
      <PageHeader
        breadcrumbs={[{ label: 'Marketing', to: '/marketing' }, { label: 'Flujos' }]}
        meta={`${FLOWS.length} flujos documentados`}
      />

      {FLOWS.map((flow) => (
        <div key={flow.id} id={`flow-${flow.id}`} style={S.flowSection}>
          <div style={S.flowCard}>
            <div style={S.flowHeader(flow.triggerColor)}>
              <div style={S.flowTrigger(flow.triggerColor)}>
                {I[flow.triggerIcon]}
              </div>
              <div style={{ flex: 1 }}>
                <h3 style={S.flowTitle}>{flow.title}</h3>
                <p style={S.flowDesc}>{flow.description}</p>
              </div>
            </div>

            {/* Landing pages list */}
            {flow.pages && flow.pages.length > 0 && (
              <div style={{
                padding: '14px 24px',
                borderBottom: '1px solid var(--border)',
                display: 'flex',
                flexWrap: 'wrap' as const,
                gap: 8,
                alignItems: 'center',
              }}>
                <span style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', marginRight: 4 }}>LANDINGS:</span>
                {flow.pages.map((pg) => (
                  <a
                    key={pg.url}
                    href={pg.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 6,
                      padding: '5px 12px',
                      background: 'var(--veil-04)',
                      border: '1px solid var(--border)',
                      borderRadius: 8,
                      fontSize: 12,
                      color: 'var(--info)',
                      textDecoration: 'none',
                      transition: 'all 0.2s',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = 'color-mix(in srgb, var(--info) 10%, transparent)'
                      e.currentTarget.style.borderColor = 'color-mix(in srgb, var(--info) 30%, transparent)'
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'var(--veil-04)'
                      e.currentTarget.style.borderColor = 'var(--veil-08)'
                    }}
                  >
                    <span style={{ color: 'var(--text-muted)' }}>{I.globe}</span>
                    {pg.label}
                    {pg.hasForm && <span style={{ fontSize: 9, padding: '1px 5px', borderRadius: 3, background: 'color-mix(in srgb, var(--success) 15%, transparent)', color: 'var(--success)', fontWeight: 700 }}>FORM</span>}
                    {pg.hasBooking && <span style={{ fontSize: 9, padding: '1px 5px', borderRadius: 3, background: 'color-mix(in srgb, var(--warning) 15%, transparent)', color: 'var(--warning)', fontWeight: 700 }}>BOOKING</span>}
                  </a>
                ))}
              </div>
            )}

            <div style={S.flowBody}>
              <FlowRow items={flow.steps} onScrollToFlow={scrollToFlow} />
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
